<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
  <z-page :title='"Pengesahan "+ tajuk'>

    <w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    width="80%"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      <template v-if="form.id">
      Kemaskini 
      </template>
      <template v-else>
        Tambah  
      </template>
    </template>

    <w-form 
      ref="form" 
      v-model="dialog.valid"
      @validate="submit1"
      @success="success"
    >
      <w-transition-bounce>
        <w-alert
          class="my0 mb2 text-light"
          v-if="$page.props.flash.error"
          error
          transition="bounce"
          plain
          round
          no-border
          dismiss
          >
            {{$page.props.flash.error}}
        </w-alert>
      </w-transition-bounce>

        <div class="grow mb4" style="min-width: 200px">
          <div class="spacer">Jenis Pengguna * :</div>
             <br>
             <w-radios v-model="form.lkp_jenis_pengguna_id" disabled @input="getPeranan()" :items="jenis_pengguna"
            :validators="[validators.required]" inline />
       </div>
      <div class="spacer"></div>
        <w-input
          outline
          label="Kategori Pengguna *"
          class="mt3"
          type="text"
          disabled
          v-model="form.x"
          :validators="[validators.required]"
        />
        <div class="spacer"></div>
        <br>
        <div class="spacer">Sijil Latikan * : <a v-if="attahecment.length > 0" :href="attahecment[0].url">{{attahecment[0].name}}</a></div>
        <br>
        <w-input type="file" :preview="false" accept="application/pdf" v-model="files" multiple>Muat Naik Sijil</w-input>
        <br>
        <!-- <p v-if="attahecment.length > 0">URL: {{ attahecment[0].url }}</p> -->
      <div class="spacer"></div>
      <w-flex wrap :gap="2">
        <div class="grow mb4" style="min-width: 200px">
        <w-input
          outline
          label="No. Kad Pengenalan *"
          class="mt3"
          type="text"
          placeholder="No. Kad Pengenalan"
          @input="acceptTypeNumber(form)"
          name="no_id"
          v-model="form.no_id"
          :validators="[validators.required]"
        />
        <template v-if="no_id_lebih_12!=''">
          <div style="color: red">
            {{ no_id_lebih_12 }}
          </div>
        </template>
        <div class="spacer"></div>
        <br>
        <w-input
          outline
          label="Emel *"
          class="mt3"
          type="email"
          placeholder="Sila Masukkan Emel"
          name="email"
          v-model="form.email"
          :validators="[validators.required, validators.email]"
        />
      </div>
      <div class="grow mb4" style="min-width: 200px ">
        <w-input
          outline
          label="Nama Penuh *"
          class="mt3"
          type="text"
          placeholder="Nama Penuh"
          name="name"
          v-model="form.name"
          :validators="[validators.required]"
        />
        <div class="spacer"></div>
        <br>
        <w-input
            outline
            label="Nombor Telefon *"
            class="mt3"
            type="tel"
            placeholder="Sila Masukkan Nombor Telefon"
            name="no_tel"
            v-model="form.no_tel"
            :validators="[validators.required, validators.numeric]"
        />
      </div>
      </w-flex>
      <div class="spacer"></div>
      <w-textarea 
          outline 
          label="Alamat*"
          placeholder="Sila Masukkan Alamat"
          class="mt3"
          name="alamat"
          v-model="form.alamat"
          type="text-area"
          :validators="[validators.required]"/>
      <div class="spacer"></div>
      <br>
      <template>
       <w-select 
          outline
          :items="poskod" 
          label="Poskod"  
          v-model="form.lkp_poskod_id"
          @input="checkPoskod()"
          />
      </template>

        <w-input
           outline
           label="Poskod"
           class="mt3"
           type="tel"
           placeholder="Sila Masukkan Poskod"
           name="poskod"
           v-model="form.kode"
           @change="getPoskodUtama()"
           :validators="[validators.required, validators.numeric]"
          />
      <div class="spacer"></div>
      <br>
      <w-select outline :items="bandar" label="Bandar *" v-model="form.lkp_bandar_id"
        @input="getPoskod(2)"
        :validators="[validators.required]"/>
      <div class="spacer"></div>
      <br>
      <w-select outline :items="negeri" label="Negeri *" v-model="form.lkp_negeri_id" @input="getBandar(2);getCawangan(2)" :validators="[validators.required]"/>
      <div class="spacer"></div>
      <br>
      <w-select 
        outline
        :items="cawangan" 
        label="Tempat Bertugas"  
        v-model="form.lkp_cawangan_id"
        v-if="form.lkp_jenis_pengguna_id==1"
        />
      <div class="spacer"></div>
      <br>
      <w-tooltip right align-bottom color="white" bg-color="blue">
          <template #activator="{ on }">
              <span v-on="on">
                <div class="spacer"></div>
                <w-input
                  outline
                  label="Sila Masukkan Kata Laluan (Kosongkan untuk tidak mengubah password) *"
                  class="mt3"
                  placeholder="Sila Masukkan Kata Laluan"
                  :type="isPassword ? 'password' : 'text'"
                  :inner-icon-right="isPassword ? 'fal fa-eye-slash' : 'fal fa-eye'"
                  @click:inner-icon-right="isPassword = !isPassword"
                  name="password"
                  v-model="form.password"
                />
              </span>
          </template>
        Medan Ini Wajib , minimum 8 aksara
      </w-tooltip>
    </w-form>

    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === false" @click="$refs.form.validate()">
        Simpan
      </w-button>
    </template>
  </w-dialog>
    <z-table ref="tbluser" title="Senarai Pengesahan" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
      <template #header-label="{ header, label, index }">
        <template v-if="header.key == 'action'">
        Tindakan
        </template>
        <template v-else>
        {{ label }}
        </template>
      </template>

      <template #item-cell.action="{ item, label, header, index }">
        <w-flex class="flex justify-center">
          <w-button class="fs-2 pr3 bs" bg-color="primary-dark1" tile @click="edit1(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini
        </w-button>
          <w-button class="fs-2 pr3 bs" bg-color="success" tile @click="pasti(item)">
            <w-icon xs class="mr2">fal fa-chevron-circle-down</w-icon> Sahkan
          </w-button>
          <w-button class="fs-2" bg-color="error-dark1" dark tile @click="destroy(item)">
            <w-icon xs class="mr2">fal fa-trash</w-icon> Tolak
          </w-button>
        </w-flex>
      </template>
    </z-table>
  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
    tajuk: Object,
    segmenName: Object,
  },
  data() {
    return {
      isPassword: true,
      isPassword1: true,
      resourceurl: 'pengesahan.'+this.segmenName,
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Utama', route: '/' },
        { label: 'Pengesahan '+this.tajuk, route: '/pengesahan' },
      ],
      form: {
        id: 0,
        name: '',
        email: '',
        status: 2,
        password_confirmation: '',
        password: '',
      },
      dialog: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          item: {name: '', email: '', mobile: ''}
        },
      poskod : [],
      bandar : [],
      negeri : [],
      jenis_pengguna: [],
      peran: [],
      cawangan: [],
      attahecment: [],
      slides:[],
    }
  },
  methods: {
      getAttahecment(item)
      {
        this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item.id, model : '\\App\\Model\\SijilUser'}).then(res => {
          this.attahecment = res
          this.slides = [];
         for (var b in this.attahecment) {
            this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
         }
        })
      },
      getCawangan(id){
         if(id == 2 || (id == 1 && this.form.lkp_negeri_id != '')){
            this.$zcomm.get(this.api_service + 'lookup/cawangan/'+this.form.lkp_negeri_id, {}).then(res => {
              this.cawangan = res
            })
         }else{
            this.$zcomm.get(this.api_service + 'lookup/cawangan/'+this.form.lkp_negeri_id, {}).then(res => {
              this.cawangan = res
            })
         }
      },
      acceptTypeNumber(form) {
          var value = form.no_id;
          var stringValue = value.toString();
          console.log(stringValue.length);
          if (stringValue.length > 12) {
             this.no_id_lebih_12 = 'No. Kad Pengenalan tidak boleh lebih dari 12 digit.';
            console.log('No. Kad Pengenalan tidak boleh lebih dari 12 digit.');
          }else{
             this.no_id_lebih_12 = '';
          }
      },
      getNegeri(){
        this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
          this.negeri = res
        })
      },

      getlkpJenisPengguna(id){
        this.$zcomm.get(this.api_service + 'lookup/jenis_pengguna', {}).then(res => {
          this.jenis_pengguna = res
        })
      },

      getBandar(item){
        if (item == 2) {
          this.form.lkp_poskod_id = '';
          this.form.lkp_bandar_id = '';
        }
        if(item == 2 || (item == 1 && this.form.lkp_bandar_id != '')){
          this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form.lkp_negeri_id, {}).then(res => {
          this.bandar = res
          })
        }else{
          this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form.lkp_negeri_id, {}).then(res => {
          this.bandar = res
          })
        }
      },

      getPoskod(item){
        if (item == 2 || this.form.lkp_bandar_id == '') {
          this.form.lkp_poskod_id = '';
        }
        if(item == 2 || (item == 1 && this.form.lkp_bandar_id != '')){
          this.$zcomm.get(this.api_service + 'lookup/poskod/'+this.form.lkp_bandar_id, {}).then(res => {
            this.poskod = res
          })
        }
      },
      getPoskodUtama(){
        this.$zcomm.get(this.api_service + 'lookup/poskod_utama/'+this.form.kode, {}).then(res => {
          // this.form.p = res.p
          this.form.lkp_negeri_id = res.lkp_negeri_id
          this.form.lkp_bandar_id = res.lkp_bandar_id
          this.form.lkp_poskod_id = res.lkp_poskod_id
          this.getPoskod(0)
          this.getBandar(0)
          this.getCawangan(0);
        })
      },

      checkPoskod(){
        if(this.form.lkp_poskod_id == null){
          this.form.p = 0
        }
      },
      tambah() {
          this.form = this.form
          this.dialog.show = true
          this.getNegeri();
          // $('#' + this.resourceurl).modal('show')
          this.form.saveButton = "Simpan"
      },
      edit1(idx) {
          this.form = idx;
          this.form.kode = idx.kode;
          this.form.saveButton = "Kemaskini";
          this.getNegeri();
          this.getBandar(1);
          this.getPoskod(1);
          this.getCawangan(1);
          this.getlkpJenisPengguna();
          this.getAttahecment(idx);
          this.dialog.show = true
      },
      submit1() {
        if (this.form.id > 0) {
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
              .then(res => {
                console.log(res);
                  this.uploadImg(res);
                  this.dialog.show = false;
                  this.$inertia.reload();
              })
              .catch(err => {
                if (err.response.data.errors.email == "The email has already been taken.")
                    {
                        this.email_wujud = "Emel sudah wujud";
                    }
                if (err.response.data.errors.no_id == "The no id has already been taken.")
                    {
                        this.no_id_wujud = "No id sudah wujud";
                    }
              })
              .finally(() => {
                  this.dialog.show = false
                  this.$inertia.reload();
              });
              this.dialog.loading = false;
        }
      },
      destroy(idx) {
          this.form.id = idx.id
          if (confirm('Adakah anda pasti untuk tolak permohonan ini?')) {
              this.$zcomm.delete(this.resourceurl + '.destroy', this.form.id)
                  .then(res => {
                    //update displayed record
                    this.sending = false;
                    this.dialog.show = false;
                    this.$inertia.visit(this.$page.url)
                    this.removeitem(res) // remove the data from list. no need to refresh page
                    if (typeof this.onAfterDelete === "function") {
                      this.onAfterDelete()
                    }
                  })
                  .finally(() => {
                    // $('#' + this.resourceurl).modal('hide')
                  });
          }
      },
      pasti(item) {
        this.loading = true;
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if(item.id > 0){
          item.sahkan = 1;
          this.$zcomm.update(this.resourceurl + '.update', item.id, item)
              .then(res => {
                console.log(res);
                  this.dialog.show = false;
                  this.$inertia.reload();
              })
              .catch(err => {

              })
              .finally(() => {
                  this.dialog.show = false
                  this.$inertia.reload();
              });
              this.dialog.loading = false;
          }
        }else{ this.loading = false;}

        }) 
      },

      uploadImg(item) 
      {  
        let formData = new FormData();
        for (var b in this.files) 
        {
             formData.append("files["+b+"]", this.files[b].file);
        }
        formData.append("model",'\\App\\Model\\SijilUser');
        formData.append("model_id", item.id);
        this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
              // this.getAttahecment();
           })
           .catch((err) => {})
           .finally(() => {});
      },
    
  },
  watch: {

  },
  mounted() {
          // this.getNegeri();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
